webpackJsonp([8029435440108],{

/***/ 229:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(4);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(9);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _Divider = __webpack_require__(6);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _Fill = __webpack_require__(5);
	
	var _Fill2 = _interopRequireDefault(_Fill);
	
	var _Wave = __webpack_require__(50);
	
	var _Wave2 = _interopRequireDefault(_Wave);
	
	var _WaveB = __webpack_require__(34);
	
	var _WaveB2 = _interopRequireDefault(_WaveB);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var query = exports.query = '** extracted graphql fragment **';
	
	var WTH = function WTH(_ref) {
	  var _ref$data = _ref.data,
	      wthbanner = _ref$data.wthbanner,
	      wthlogo = _ref$data.wthlogo,
	      wthone = _ref$data.wthone,
	      wthtwo = _ref$data.wthtwo,
	      wththree = _ref$data.wththree,
	      wthphone = _ref$data.wthphone,
	      wthmac = _ref$data.wthmac,
	      wall = _ref$data.wall,
	      rcsa = _ref$data.rcsa,
	      rcsb = _ref$data.rcsb,
	      rcsc = _ref$data.rcsc;
	  return _react2.default.createElement(
	    'section',
	    null,
	    _react2.default.createElement('article', { style: { backgroundImage: 'url("' + wthbanner.sizes.src + '"), url("' + wthbanner.sizes.tracedSVG + '")', backgroundPosition: 'center', backgroundSize: 'cover', minHeight: '50vh' } }),
	    _react2.default.createElement(
	      'article',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'container centerAlign', style: { paddingTop: '0' } },
	        _react2.default.createElement(_gatsbyImage2.default, { className: 'caseLogo', sizes: wthlogo.wthlogochild.sizes, alt: 'WanderThirst Hostels', style: { borderRadius: '50rem' } }),
	        _react2.default.createElement(
	          'h1',
	          { className: 'smallerHone' },
	          'WanderThirst Hostels'
	        ),
	        _react2.default.createElement('img', { src: _Fill2.default, alt: 'Nisadhya - Divider', style: { margin: '0.75rem 0' } }),
	        _react2.default.createElement(
	          'p',
	          { style: { marginBottom: '0' } },
	          'Increasing booking by 90% with awareness and optimization campaign on Social Media, Google and their online booking agents (OTA).'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'article',
	      { style: { backgroundImage: 'url("' + wall.sizes.src + '"), url("' + wall.sizes.tracedSVG + '")', backgroundPosition: 'center', backgroundSize: 'contain' } },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'container full-Width centerAlign', style: { color: '#fff', alignItems: 'flex-start', justifyContent: 'space-between' } },
	          _react2.default.createElement(
	            'div',
	            { className: 'half-Width-30 mobBottommargin' },
	            _react2.default.createElement(
	              'p',
	              { style: { fontSize: '3rem' } },
	              '8.8%'
	            ),
	            _react2.default.createElement(
	              'p',
	              { style: { marginBottom: '0' } },
	              'lift in daily camera captures'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'half-Width-30 mobBottommargin' },
	            _react2.default.createElement(
	              'p',
	              { style: { fontSize: '3rem' } },
	              '92%'
	            ),
	            _react2.default.createElement(
	              'p',
	              { style: { marginBottom: '0' } },
	              'on-target reach on Facebook'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'half-Width-30' },
	            _react2.default.createElement(
	              'p',
	              { style: { fontSize: '3rem' } },
	              '87%'
	            ),
	            _react2.default.createElement(
	              'p',
	              { style: { marginBottom: '0' } },
	              'on-target reach on Instagram'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'article',
	      { style: { backgroundColor: '#f8f8f8' } },
	      _react2.default.createElement(
	        'div',
	        { className: 'container centerAlign' },
	        _react2.default.createElement(_gatsbyImage2.default, { sizes: wthmac.wthmacchild.sizes, alt: 'Spa Prana', style: { width: '100%', marginBottom: '1.5rem' } }),
	        _react2.default.createElement(
	          'h2',
	          { className: 'smallerHone' },
	          'Their Story.'
	        ),
	        _react2.default.createElement('img', { src: _Fill2.default, alt: 'Nisadhya - Divider', style: { margin: '0.75rem 0' } }),
	        _react2.default.createElement(
	          'p',
	          { style: { fontSize: '1.38316rem' } },
	          _react2.default.createElement(
	            'span',
	            { className: 'gradient' },
	            'Meet WanderThirst Hostels.'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          { style: { marginBottom: '0' } },
	          'Located in the peaceful corner of the popular tourist destination at Kaldhara, Thamel, WanderThirst Hostels, established in 2016, cater towards backpackers and travellers from all around the world who seek accommodation for an affordable budget equipped for people all around the world who love discovering new places and meeting new people.'
	        )
	      ),
	      _react2.default.createElement('img', { src: _Wave2.default, alt: 'Divider', style: { width: '100%', display: 'block' } })
	    ),
	    _react2.default.createElement(
	      'article',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'container full-Width' },
	        _react2.default.createElement(
	          'div',
	          { className: 'half-Width-50 mobBottommargin' },
	          _react2.default.createElement(_gatsbyImage2.default, { sizes: wthone.wthonechild.sizes, alt: 'Spa Prana', style: { width: '100%' } })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'half-Width-50 paddingLeft' },
	          _react2.default.createElement(
	            'div',
	            { style: { display: 'block' } },
	            _react2.default.createElement(
	              'h1',
	              { className: 'smallerHone' },
	              'Their Goal.'
	            ),
	            _react2.default.createElement('img', { src: _Fill2.default, alt: 'Nisadhya - Divider', style: { margin: '0.75rem 0' } }),
	            _react2.default.createElement(
	              'p',
	              { style: { fontSize: '1.38316rem' } },
	              _react2.default.createElement(
	                'span',
	                { className: 'gradient' },
	                'Building awareness and winning sales.'
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              { style: { marginBottom: '0' } },
	              'WanderThirst Hostels wanted to increase their brand awareness through social media optimization and increase their online booking numbers through their website as well as OTAs during tourist seasons in Nepal.'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'article',
	      { style: { backgroundColor: '#f8f8f8' } },
	      _react2.default.createElement(
	        'div',
	        { className: 'container full-Width reverseRow' },
	        _react2.default.createElement(
	          'div',
	          { className: 'half-Width-50 mobBottommargin' },
	          _react2.default.createElement(_gatsbyImage2.default, { sizes: wthone.wthonechild.sizes, alt: 'Spa Prana', style: { width: '100%' } })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'half-Width-50 paddingRight' },
	          _react2.default.createElement(
	            'div',
	            { style: { display: 'block' } },
	            _react2.default.createElement(
	              'h1',
	              { className: 'smallerHone' },
	              'Our Solution.'
	            ),
	            _react2.default.createElement('img', { src: _Fill2.default, alt: 'Nisadhya - Divider', style: { margin: '0.75rem 0' } }),
	            _react2.default.createElement(
	              'p',
	              { style: { fontSize: '1.38316rem' } },
	              _react2.default.createElement(
	                'span',
	                { className: 'gradient' },
	                'Building profile through Website, Social Media and OTA optimizations.'
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Before we started working with WanderThirst Hostels, they did not have a proper website, nor did they run an active social media account (both Facebook and Instagram) or have a proper OTA optimization, which is very important for a hostel.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'To build brand awareness our first step was to create a website from scratch and through appropriate SEO, WanderThirst Hostels ranked at the top in the search engines. We updated daily contents on their social medias and created videos about the hostel that would attract the right target audience to find WanderThirst at the right time (tourist season in Nepal).'
	            ),
	            _react2.default.createElement(
	              'p',
	              { style: { marginBottom: '0' } },
	              'With their brand awareness now built, soon they were ranking high on the OTAs (Trip Advisor, Booking.com and Hostel World) making it quick and easy for a lot of eyes to see the hostel and winning sales.'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement('img', { src: _Wave2.default, alt: 'Divider', style: { width: '100%', display: 'block' } })
	    ),
	    _react2.default.createElement(
	      'article',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'container full-Width', style: { justifyContent: 'space-between' } },
	        _react2.default.createElement(
	          'div',
	          { className: 'half-Width-49 mobBottommargin' },
	          _react2.default.createElement(_gatsbyImage2.default, { className: 'caseImg', sizes: wthtwo.wthtwochild.sizes, alt: 'Spa Prana', style: { width: '100%' } })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'half-Width-49' },
	          _react2.default.createElement(_gatsbyImage2.default, { className: 'caseImg', sizes: wththree.wththreechild.sizes, alt: 'Spa Prana', style: { width: '100%' } })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'article',
	      { style: { backgroundColor: '#f8f8f8' } },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'centerAlign', style: { display: 'block' } },
	            _react2.default.createElement(
	              'h1',
	              { className: 'smallerHone' },
	              'Products Used'
	            ),
	            _react2.default.createElement('img', { src: _Divider2.default, alt: 'Nisadhya - Divider', style: { margin: '0.75rem 0' } })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'full-Width', style: { alignItems: 'flex-start', justifyContent: 'space-between' } },
	          _react2.default.createElement('div', { className: 'half-Width-30 mobBottommargin' }),
	          _react2.default.createElement('div', { className: 'half-Width-30 mobBottommargin' }),
	          _react2.default.createElement('div', { className: 'half-Width-30' })
	        )
	      ),
	      _react2.default.createElement('img', { src: _Wave2.default, alt: 'Divider', style: { width: '100%', display: 'block' } })
	    ),
	    _react2.default.createElement(
	      'article',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'centerAlign', style: { display: 'block' } },
	            _react2.default.createElement(
	              'h1',
	              { className: 'smallerHone' },
	              'Related Case Study'
	            ),
	            _react2.default.createElement('img', { src: _Divider2.default, alt: 'Nisadhya - Divider', style: { margin: '0.75rem 0' } })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'full-Width', style: { alignItems: 'flex-start', justifyContent: 'space-between' } },
	          _react2.default.createElement(
	            'div',
	            { className: 'half-Width-30 mobBottommargin' },
	            _react2.default.createElement(
	              'div',
	              { className: 'case-studies' },
	              _react2.default.createElement(
	                'div',
	                { style: { overflow: 'hidden' } },
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: '/case-studies/kcl-astute/' },
	                  _react2.default.createElement(_gatsbyImage2.default, { className: 'case-studies-img', sizes: rcsa.rcsachild.sizes, alt: '' })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: { padding: '1.0875rem' } },
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'smallerHone' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'gradient' },
	                    'KCL Astute.'
	                  )
	                ),
	                _react2.default.createElement('img', { src: _Fill2.default, style: { margin: '.75rem 0' }, alt: 'Nisadhya - Divider' }),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'KCL Astute Capital Limited is a Merchant Banker licensed by Securities Board of Nepal (SEBON) to render Portfolio Management Services.'
	                ),
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: '/case-studies/kcl-astute/', className: 'slide gradient' },
	                  'View Case Study'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'half-Width-30' },
	            _react2.default.createElement(
	              'div',
	              { className: 'case-studies' },
	              _react2.default.createElement(
	                'div',
	                { style: { overflow: 'hidden' } },
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: '/case-studies/wanderthirst-hostels/' },
	                  _react2.default.createElement(_gatsbyImage2.default, { className: 'case-studies-img', sizes: rcsb.rcsbchild.sizes, alt: '' })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: { padding: '1.0875rem' } },
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'smallerHone' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'gradient' },
	                    'Wanderthirst Hostels.'
	                  )
	                ),
	                _react2.default.createElement('img', { src: _Fill2.default, style: { margin: '.75rem 0' }, alt: 'Nisadhya - Divider' }),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Prabhu Pay App allows its users to simplify the payment process. With this App, the consumers can easily make payments for the goods purchased and services rendered.'
	                ),
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: '/case-studies/wanderthirst-hostels/', className: 'slide gradient' },
	                  'View Case Study'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement('div', { className: 'half-Width-30' })
	        )
	      )
	    )
	  );
	};
	
	exports.default = WTH;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-case-studies-wanderthirst-hostels-js-522f1bb0e80568595d15.js